import styled from "styled-components";
import useVisible from "../Shared/useVisible";
import Button from "../../Common/Components/Button";
import { ReactComponent as DownAngle } from "../../../assets/img/icons/DownAngle.svg";
import Sort from "../../../assets/img/icons/Sort.svg";
import BackArrow from "../../../assets/img/icons/BackArrow.svg";
import { Radio } from "antd";
import { FC, useEffect, useState } from "react";
import store, { RootState } from "store";
import { useSelector } from "react-redux";
import { getDeliveredContactsList, resetFilterLabel } from "./action";
import { CONTACTS_BY_FILTER_ENUM, getDisplayLabel, getSelectedLabel, getSelectedType } from "./utils";
import { ReactComponent as SearchCross } from "../../../assets/img/icons/SearchCross.svg";
import { CONTACT_ANALYTICS } from "constants/types";
import { removeOnClickBubble } from "utils";
import { getConstantCampaignEmailId } from "../utils";

interface IContactsByFilterComponent {
  tab?: string;
  searchedText: string;
  accountId: number
}
const DEFAULT_PAGE_LIMIT = 20;
const re = /^[0-9\b]+$/;
let numValue = "";
let prevType = 0;
let prevTextValue = "";
let prevLabel = "";

const ContactsByFilterComponent: FC<IContactsByFilterComponent> = (props: IContactsByFilterComponent) => {
  const { searchedText, accountId } = props;

  const { ref, isVisible, setIsVisible } = useVisible(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [equalTextValue, setEqualTextValue] = useState("");
  const [lessTextValue, setLessTextValue] = useState("");
  const [greaterTextValue, setGreaterTextValue] = useState("");
  const [lessEqualTextValue, setLessEqualTextValue] = useState("");
  const [greaterEqualTextValue, setGreaterEqualTextValue] = useState("");
  const [appliedText, setAppliedText] = useState("");
  const [selectedFilter, setSelectedFilter] = useState(0);
  const [appliedFilter, setAppliedFilter] = useState(0);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [appliedLabel, setAppliedLabel] = useState("");
  const [filterLabel, setFilterLabel] = useState("Contacts by");

  //Redux states
  const sortType = useSelector((state: RootState) => state.contactAnalytics.deliveredSortType);
  const sortBy = useSelector((state: RootState) => state.contactAnalytics.deliveredSortBy);
  const contactsByFilter = useSelector((state: RootState) => state.contactAnalytics.contactsByFilter);
  const AllCampaignsFilterCheck = useSelector(
    (state: RootState) => state.analyticsDashboard.appliedCampaignsFilters.isAllCampaigns
  );
  const isParameterApplied = (parameterName: string) => {
    const selectedLabel = getSelectedLabel(parameterName) ?? "";
    return filterLabel.includes(selectedLabel);
  };
  const selectParameterFlow = (parameterName: string) => {
    prevLabel = "";
    prevTextValue = "";
    prevType = 0;
    const isApplied = isParameterApplied(parameterName);
    setSelectedLabel(parameterName);
    if (!isApplied) {
      //let user Set new params;
      clearTextValues();
      setSelectedFilter(0);
    } else {
      // show user old params
      setSelectedFilter(appliedFilter);
      setTextValueToAppliedValue(appliedFilter);
      numValue = appliedText;
    }
  };

  const getSelectedFilter = () => {
    let label = "";
    switch (selectedFilter) {
      case 1:
        label = getSelectedLabel(selectedLabel) + " = " + equalTextValue;
        setFilterLabel(label);
        store.dispatch({ type: CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER, payload: label });
        return label;
      case 2:
        label = getSelectedLabel(selectedLabel) + " < " + lessTextValue;
        store.dispatch({ type: CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER, payload: label });
        setFilterLabel(label);
        return label;
      case 3:
        label = getSelectedLabel(selectedLabel) + " > " + greaterTextValue;
        store.dispatch({ type: CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER, payload: label });
        setFilterLabel(label);
        return label;
      case 4:
        label = getSelectedLabel(selectedLabel) + " <= " + lessEqualTextValue;
        store.dispatch({ type: CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER, payload: label });
        setFilterLabel(label);
        return label;
      case 5:
        label = getSelectedLabel(selectedLabel) + " >= " + greaterEqualTextValue;
        store.dispatch({ type: CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER, payload: label });
        setFilterLabel(label);
        return label;
    }
  };

  const storeTextValue = () => {
    switch (selectedFilter) {
      case 1:
        setAppliedText(equalTextValue);
        break;
      case 2:
        setAppliedText(lessTextValue);
        break;
      case 3:
        setAppliedText(greaterTextValue);
        break;
      case 4:
        setAppliedText(lessEqualTextValue);
        break;
      case 5:
        setAppliedText(greaterEqualTextValue);
        break;
    }
  };
  const setTextValueToAppliedValue = (appliedFilter: number) => {
    switch (appliedFilter) {
      case 1:
        setEqualTextValue(appliedText);
        setLessTextValue("");
        setGreaterTextValue("");
        setLessEqualTextValue("");
        setGreaterEqualTextValue("");
        break;
      case 2:
        setEqualTextValue("");
        setLessTextValue(appliedText);
        setGreaterTextValue("");
        setLessEqualTextValue("");
        setGreaterEqualTextValue("");
        break;
      case 3:
        setEqualTextValue("");
        setLessTextValue("");
        setGreaterTextValue(appliedText);
        setLessEqualTextValue("");
        setGreaterEqualTextValue("");
        break;
      case 4:
        setEqualTextValue("");
        setLessTextValue("");
        setGreaterTextValue("");
        setLessEqualTextValue(appliedText);
        setGreaterEqualTextValue("");
        break;
      case 5:
        setEqualTextValue("");
        setLessTextValue("");
        setGreaterTextValue("");
        setLessEqualTextValue("");
        setGreaterEqualTextValue(appliedText);
        break;
    }
  };
  const getFilteredResults = (reset: boolean) => {
    store.dispatch({
      type: CONTACT_ANALYTICS.DELIVERED_RESET,
    });
    let analyticsDashboard = store.getState().analyticsDashboard;
    let analyticsGraph = store.getState().analyticsGraph;
    let { appliedCampaignIds, appliedAssetsIds, excludeCampaignsIds, excludeAssetsIds } =
      analyticsDashboard;
    let { isShareProfile, isDailyIQ, isWeeklyAccountInsights } = analyticsDashboard.appliedCampaignsFilters;
    let { startDate, endDate } = analyticsGraph;
    let _params: any = {
      limit: DEFAULT_PAGE_LIMIT,
      tab: "delivered",
      searchWord: searchedText,
      offset: 0,
      sortBy: sortBy,
      sortType: sortType,
      emailIds: appliedAssetsIds,
      startDate: startDate,
      endDate: endDate,
      allCampaigns: AllCampaignsFilterCheck,
      campaignIds: appliedCampaignIds,
    };
    if (!reset) {
      storeTextValue();
    } else {
      setAppliedText("");
    }

    if (isShareProfile || isDailyIQ || isWeeklyAccountInsights) {
      let email_campaign_id = getConstantCampaignEmailId({ isShareProfile, isDailyIQ, isWeeklyAccountInsights });
      _params["emailIds"] = [email_campaign_id];
      _params["campaignIds"] = [email_campaign_id];
    }

    if (AllCampaignsFilterCheck) {
      _params["excludeCampaignsIds"] = excludeCampaignsIds;
      _params["excludeAssetsIds"] = excludeAssetsIds;
    }

    if (!reset) _params["contactsByFilter"] = getSelectedFilter();
    if (accountId) _params['accountId'] = accountId
    getDeliveredContactsList(_params, accountId > 0);
  };

  const clearTextValues = () => {
    setEqualTextValue("");
    setLessTextValue("");
    setGreaterTextValue("");
    setLessEqualTextValue("");
    setGreaterEqualTextValue("");
    store.dispatch({ type: CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER, payload: "" });
  };

  const clearFields = () => {
    setEqualTextValue("");
    setLessTextValue("");
    setGreaterTextValue("");
    setLessEqualTextValue("");
    setGreaterEqualTextValue("");
    setSelectedFilter(0);
    resetFilterLabel();
    setFilterLabel("Contacts by");
    prevLabel = "";
    prevTextValue = "";
    prevType = 0;
  };
  const clear = (e: any) => {
    getFilteredResults(true);
    removeOnClickBubble(e);
    setSelectedFilter(0);
    setFilterLabel("Contacts by");
    setEqualTextValue("");
    setLessTextValue("");
    setGreaterTextValue("");
    setLessEqualTextValue("");
    setGreaterEqualTextValue("");
    setSelectedLabel("");
    setIsVisible2(false);
    setIsVisible(false);
    setAppliedFilter(0);
    setAppliedText("");
    store.dispatch({ type: CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER, payload: "" });
  };

  useEffect(() => {
    if (contactsByFilter) {
      setFilterLabel(contactsByFilter);
      if (contactsByFilter !== "") {
        prevLabel = getDisplayLabel(contactsByFilter.split(" ")[0]) ?? "";
        prevType = getSelectedType(contactsByFilter.split(" ")[1]) ?? 0;
        prevTextValue = contactsByFilter.split(" ")[2];
      }
    }
  }, [contactsByFilter]);

  useEffect(() => {
    if (isVisible === false && isVisible2 === true && filterLabel === "Contacts by") {
      numValue = "";
      clearFields();
    }
  }, [isVisible, isVisible2]);
  return (
    <Wrapper>
      <div
        className={`dropdown-selecter ${isVisible ? "active" : ""}`}
        onClick={() => {
          if (filterLabel === "Contacts by") {
            setSelectedFilter(0);
            setIsVisible2(false);
            setIsVisible(!isVisible);
          } else {
            setSelectedLabel(appliedLabel);
            setSelectedFilter(appliedFilter);
            setTextValueToAppliedValue(appliedFilter);
            setIsVisible(!isVisible);
            setIsVisible2(true);
            numValue = appliedText;
          }
        }}
      >
        <div className="label">
          <img src={Sort} />
          <span className="label-eclips" id="contact-filter-selected-value">
            &nbsp; {contactsByFilter !== "" && contactsByFilter !== undefined ? contactsByFilter : filterLabel}
          </span>
          {filterLabel !== "Contacts by" && (
            <span className="cleaclear-search">
              <SearchCross
                onClick={(e) => {
                  clear(e);
                }}
              />
            </span>
          )}
        </div>

        <div className="d-flex">
          <div className="seprator"></div>
          <div className="p-2">
            <DownAngle />
          </div>
        </div>
      </div>
      <div ref={ref} className={`dropdown-options ${isVisible ? "show" : ""}`}>
        {/* Toggle class "show" to show and hide dropdown */}
        <div className="dropdown-options-inner">
          <div
            className={`dropdown-wrapper ${isVisible2 ? "show-part2" : ""}`}
            id={isVisible2 ? "show-part2" : "show-part1"}
          >
            <div className={`dropdown-top-filters`} id="show-part1-wrapper">
              <ul>
                <li
                  onClick={() => {
                    numValue = "";
                    selectParameterFlow("Unique Opens");
                    setIsVisible2(true);
                  }}
                >
                  <label>Unique Opens</label>
                </li>
                <li
                  onClick={() => {
                    numValue = "";
                    selectParameterFlow("Total Opens");
                    setIsVisible2(true);
                  }}
                >
                  <label>Total Opens</label>
                </li>
                <li
                  onClick={() => {
                    numValue = "";
                    selectParameterFlow("Unique Clicks");
                    setIsVisible2(true);
                  }}
                >
                  <label>Unique Clicks</label>
                </li>
                <li
                  onClick={() => {
                    numValue = "";
                    selectParameterFlow("Total Clicks");
                    setIsVisible2(true);
                  }}
                >
                  <label>Total Clicks</label>
                </li>
              </ul>
            </div>
            <div className="dropdown-v2" id="show-part2-wrapper">
              <div className="header-dropdown">
                <div
                  className="back-main"
                  onClick={() => {
                    setIsVisible2(false);
                    setIsVisible(true);
                  }}
                >
                  <img src={BackArrow} alt="<" />
                  <span className="back-label">Back</span>
                </div>
                <span className="label-dropwon-v2">Filter Contact where</span>
              </div>
              <div className="body-dropdown">
                <span className="main-label">{prevLabel !== "" ? prevLabel : selectedLabel}</span>
                <Radio.Group name="radiogroup" value={prevType > 0 ? prevType : selectedFilter}>
                  <ul>
                    <li>
                      <Radio
                        value={1}
                        onChange={(e) => {
                          numValue = "";
                          clearFields();
                          setSelectedFilter(1);
                        }}
                        defaultChecked={
                          prevType === CONTACTS_BY_FILTER_ENUM.EQUALS && prevTextValue !== "" ? true : false
                        }
                        id="equal-radio"
                      >
                        Equals
                      </Radio>
                      <input
                        className={
                          selectedFilter === 1 || prevType === CONTACTS_BY_FILTER_ENUM.EQUALS ? "" : "disabled"
                        }
                        type="text"
                        value={
                          prevType === CONTACTS_BY_FILTER_ENUM.EQUALS && prevTextValue !== ""
                            ? prevTextValue
                            : equalTextValue
                        }
                        onChange={(e) => {
                          if (re.test(e.target.value) || e.target.value === "") {
                            numValue = e.target.value;
                            setEqualTextValue(e.target.value);
                            prevTextValue = "";
                          }
                        }}
                        id="equals-input"
                      />
                    </li>
                    <li>
                      <Radio
                        value={2}
                        onChange={(e) => {
                          numValue = "";
                          clearFields();
                          setSelectedFilter(2);
                        }}
                        defaultChecked={
                          prevType === CONTACTS_BY_FILTER_ENUM.LESS && prevTextValue !== "" ? true : false
                        }
                        id="less-radio"
                      >
                        Less than
                      </Radio>
                      <input
                        className={
                          selectedFilter === 2 || prevType === CONTACTS_BY_FILTER_ENUM.LESS ? "" : "disabled"
                        }
                        type="text"
                        value={
                          prevType === CONTACTS_BY_FILTER_ENUM.LESS && prevTextValue !== ""
                            ? prevTextValue
                            : lessTextValue
                        }
                        onChange={(e) => {
                          if (re.test(e.target.value) || e.target.value === "") {
                            numValue = e.target.value;
                            setLessTextValue(e.target.value);
                            prevTextValue = "";
                          }
                        }}
                        id="less-then-input"
                      />
                    </li>
                    <li>
                      <Radio
                        value={3}
                        onChange={(e) => {
                          numValue = "";
                          clearFields();
                          setSelectedFilter(3);
                        }}
                        defaultChecked={
                          prevType === CONTACTS_BY_FILTER_ENUM.GREATER && prevTextValue !== "" ? true : false
                        }
                        id="greater-radio"
                      >
                        Greater than
                      </Radio>
                      <input
                        className={
                          selectedFilter === 3 || prevType === CONTACTS_BY_FILTER_ENUM.GREATER ? "" : "disabled"
                        }
                        type="text"
                        value={
                          prevType === CONTACTS_BY_FILTER_ENUM.GREATER && prevTextValue !== ""
                            ? prevTextValue
                            : greaterTextValue
                        }
                        onChange={(e) => {
                          if (re.test(e.target.value) || e.target.value === "") {
                            numValue = e.target.value;

                            setGreaterTextValue(e.target.value);
                            prevTextValue = "";
                          }
                        }}
                        id="greater-then-input"
                      />
                    </li>
                    <li>
                      <Radio
                        value={4}
                        onChange={(e) => {
                          numValue = "";
                          clearFields();
                          setSelectedFilter(4);
                        }}
                        defaultChecked={
                          prevType === CONTACTS_BY_FILTER_ENUM.LESS_OR_EQUAL && prevTextValue !== "" ? true : false
                        }
                        id="less-or-equal-radio"
                      >
                        Less than or equal to
                      </Radio>
                      <input
                        className={
                          selectedFilter === 4 || prevType === CONTACTS_BY_FILTER_ENUM.LESS_OR_EQUAL
                            ? ""
                            : "disabled"
                        }
                        type="text"
                        value={
                          prevType === CONTACTS_BY_FILTER_ENUM.LESS_OR_EQUAL && prevTextValue !== ""
                            ? prevTextValue
                            : lessEqualTextValue
                        }
                        onChange={(e) => {
                          if (re.test(e.target.value) || e.target.value === "") {
                            numValue = e.target.value;

                            setLessEqualTextValue(e.target.value);
                            prevTextValue = "";
                          }
                        }}
                        id="less-or-equal-input"
                      />
                    </li>
                    <li>
                      <Radio
                        value={5}
                        onChange={(e) => {
                          numValue = "";
                          clearFields();
                          setSelectedFilter(5);
                        }}
                        defaultChecked={
                          prevType === CONTACTS_BY_FILTER_ENUM.GREATER_OR_EQUAL && prevTextValue !== ""
                            ? true
                            : false
                        }
                        id="greater-or-equal-radio"
                      >
                        Greater than or equal to
                      </Radio>
                      <input
                        className={
                          selectedFilter === 5 || prevType === CONTACTS_BY_FILTER_ENUM.GREATER_OR_EQUAL
                            ? ""
                            : "disabled"
                        }
                        type="text"
                        value={
                          prevType === CONTACTS_BY_FILTER_ENUM.GREATER_OR_EQUAL && prevTextValue !== ""
                            ? prevTextValue
                            : greaterEqualTextValue
                        }
                        onChange={(e) => {
                          if (re.test(e.target.value) || e.target.value === "") {
                            numValue = e.target.value;

                            setGreaterEqualTextValue(e.target.value);
                            prevTextValue = "";
                          }
                        }}
                        id="greater-or-equals-input"
                      />
                    </li>
                  </ul>
                </Radio.Group>
                <div className="d-flex justify-content-end ps-3 pt-4 pb-3">
                  <Button
                    value="Cancel"
                    className="btn-sm-secondary me-2"
                    id="cancel-contact-filter"
                    onClick={() => {
                      // if (filterLabel === "Contacts by") {
                      numValue = "";
                      clearFields();
                      setFilterLabel("Contacts by");
                      store.dispatch({ type: CONTACT_ANALYTICS.SET_CONTACTS_BY_FILTER, payload: "" });
                      setIsVisible2(false);
                      setIsVisible(false);
                      getFilteredResults(true);
                    }}
                  />
                  <Button
                    value="Apply"
                    className={`btn-sm-primary ${numValue === "" ? "disabled" : ""}`}
                    id="apply-contact-filter"
                    onClick={() => {
                      if (getFilteredResults) getFilteredResults(false);
                      setIsVisible2(false);
                      setIsVisible(false);
                      setAppliedFilter(selectedFilter);
                      setAppliedLabel(selectedLabel);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default ContactsByFilterComponent;

const Wrapper = styled.div`
  position: relative;
  .disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  .dropdown-selecter {
    border: 1px solid #dadada;
    min-width: 170px;
    background: #fff;
    border-radius: 8px;
    min-height: 36px;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
    padding-right: 2px;
    height: 38px;
    float: right;
    width: auto;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-width: 150px;
      border-radius: 6px;
      height: 30px;
      min-height: 30px;
    }
    &:focus,
    &:active,
    &.active {
      box-shadow: 0 0 0 0.1rem rgb(40 167 69 / 50%);
    }
    .label {
      color: #7e7e7e;
      font-size: 16px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      flex-wrap: wrap;
      padding: 2px 0px 2px 4px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: calc(100% - 30px);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
        margin-top: 5px;
      }
      img {
        margin-top: 3px;
        float: left;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 15px;
        }
      }
      .clear-search {
        float: right;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: -3px;
        }
      }
      .label-eclips {
        /* width: calc(100% - 40px); */
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: block;
        float: left;
        min-width: 80px;
        max-width: 200px;
      }
    }
    .seprator {
      -webkit-align-self: stretch;
      -ms-flex-item-align: stretch;
      align-self: stretch;
      background-color: hsl(0, 0%, 80%);
      margin-bottom: 8px;
      margin-top: 8px;
      width: 1px;
      box-sizing: border-box;
      + .p-2 {
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding-top: 3px !important;
          padding-bottom: 3px !important;
        }
      }
    }
  }
  .dropdown-options {
    background: #fff;
    position: absolute;
    top: 40px;
    right: 0px;
    z-index: 9;
    min-width: 100%;
    width: auto;
    border-radius: 8px;
    width: 280px;
    transition-duration: 0.5s;
    overflow: hidden;
    height: 0px;
    opacity: 0;
    box-shadow: 0px 5px 14px 0px rgb(0 0 0 / 28%);
    &.show {
      height: auto;
      opacity: 1;
    }
    .dropdown-options-inner {
      border: 1px solid #def6e6;
      box-shadow: 0 0 40px 0 rgb(0 0 0 / 28%);
      background: #fff;
      border-radius: 8px;
      float: left;
      width: 100%;
      .message-limit {
        float: left;
        width: 100%;
        padding: 15px;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        font-family: "Roboto", sans-serif;
        color: #ffa112;
        background: #ebf5ee;
      }
      .dropdown-header {
        background: #def6e6;
        color: #27ce0a;
        font-weight: 500;
        font-size: 16px;
        line-height: 40px;
        font-family: "Roboto", sans-serif;
        padding: 10px 16px 0 16px;
        border-radius: 8px 8px 0 0;
        float: left;
        width: 100%;
        svg {
          height: 12px;
          width: 16px;
          margin-right: 12px;
        }
        .sub-header {
          border: 1px solid #dadada;
          padding: 10px;
          background: #f7f7f7;
          float: left;
          margin: 10px -17px 0 -17px;
          width: calc(100% + 34px);
        }
      }
      .dropdown-wrapper {
        float: left;
        width: 100%;
        max-height: 450px;
        overflow: auto;
        &::-webkit-scrollbar {
          display: none;
        }
        &.show-part2 {
          .dropdown-top-filters {
            display: none;
          }
          .dropdown-v2 {
            display: block;
          }
        }
        .dropdown-v2 {
          display: none;
          .header-dropdown {
            background: #f7f7f7;
            border-bottom: 1px solid #dadada;
            padding: 16px 16px 12px 16px;
            float: left;
            width: 100%;
            .back-main {
              cursor: pointer;
              float: left;
              width: 100%;
              img {
                width: 15px;
              }
              .back-label {
                padding-left: 8px;
                color: #424b50;
                font-size: 16px;
                font-weight: 500;
                font-family: "Roboto", sans-serif;
              }
            }
            .label-dropwon-v2 {
              color: #7e7e7e;
              font-size: 12px;
              font-weight: 500;
              font-family: "Roboto", sans-serif;
              padding-left: 24px;
              margin-top: -5px;
              float: left;
              display: block;
            }
          }
          .body-dropdown {
            padding: 15px 8px 12px 15px;
            float: left;
            width: 100%;
            .main-label {
              color: #424b50;
              font-size: 14px;
              font-weight: 500;
              font-family: "Roboto", sans-serif;
              margin-top: 10px;
              float: left;
              width: 100%;
            }
            ul {
              margin: 0;
              padding: 0;
              li {
                padding: 5px 0;
                .ant-radio-wrapper {
                  span {
                    color: #7e7e7e;
                    font-size: 14px;
                    font-weight: 500;
                    font-family: "Roboto", sans-serif;
                    letter-spacing: -0.35px;
                  }
                }
                input[type="text"] {
                  float: right;
                  width: 65px;
                  border-radius: 13px;
                  border: 1px solid #dadada;
                  color: #7e7e7e;
                  font-size: 16px;
                  font-weight: 500;
                  font-family: "Roboto", sans-serif;
                  line-height: 16px;
                  padding: 2px 8px;
                  &:focus,
                  &:active,
                  &:focus-visible {
                    outline: none;
                    border: 1px solid #dadada;
                    outline-offset: 0px;
                    border-color: inherit;
                    -webkit-box-shadow: none;
                    box-shadow: none;
                    background: transparent;
                    box-shadow: 0 0 0 0.1rem rgb(40 167 69 / 50%);
                  }
                }
              }
            }
          }
        }
      }
      .dropdown-top-filters {
        padding: 16px 16px 16px 16px;
        float: left;
        width: 100%;
        h4 {
          color: #424b50;
          font-size: 14px;
          font-weight: 500;
          font-family: "Roboto", sans-serif;
          margin: 0;
          line-height: 40px;
          width: 100%;
          float: left;
        }
        ul {
          width: 100%;
          float: left;
          display: block;
          padding: 0 0 0 20px;
          margin: 0;
          li {
            list-style-type: none;
            margin: 5px 0;
            width: 100%;
            display: block;
            float: left;
            label {
              font-family: "Roboto", sans-serif;
              color: #7e7e7e;
              font-size: 16px;
              font-weight: 500;
              cursor: pointer;
              display: block;
              padding: 0px 0;
              float: left;
              &:hover {
                color: #27ce0a;
              }
              .ant-checkbox-wrapper {
                display: inline-block;
                float: left;
                &::after {
                  display: none;
                }
              }
              > div {
                /* margin-top: -2px; */
                float: left;
                margin: 8px 12px;
              }
            }
          }
        }
      }
      .dropdown-body {
        padding: 0 16px;
        width: 100%;
        float: left;
        ul {
          width: 100%;
          float: left;
          padding: 20px 20px 20px 0px;
          list-style-type: none;
          li {
            width: 100%;
            float: left;
            padding: 0;
            margin: 0;
            .label {
              font-family: "Roboto", sans-serif;
              color: #7e7e7e;
              font-size: 14px;
              font-weight: 500;
              cursor: pointer;
              display: block;
              padding: 5px 0;
              line-height: 30px;
              white-space: nowrap;
              text-overflow: ellipsis;
              word-break: keep-all;
              overflow: hidden;
              width: 165px;
              min-width: 165px;
              transition-duration: 0.5s;
            }
            .tick {
              opacity: 0;
              transition-duration: 0.5s;
              margin-right: 13px;
              float: left;
              svg {
                height: 12px;
                width: 16px;
                vertical-align: baseline;
              }
            }
            .current {
              color: #27ce0a;
              opacity: 1;
            }
          }
        }
      }
    }
  }
`;
